import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const youtubeWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/youtube', component: () => import('./pages/OverviewPage.js') },
    { path: '/youtube/entry', component: () => import('./pages/EntryPage.js') },
    { path: '/youtube/daily', component: () => import('./pages/DailyPage.js') },
    { path: '/youtube/channels', component: () => import('./pages/ChannelsPage.js') },
    {
      path: '/youtube/channels/$channelId',
      component: () => import('./pages/ChannelDetailPage.js'),
    },
    { path: '/youtube/milestones', component: () => import('./pages/MilestonesPage.js') },
    { path: '/youtube/settings', component: () => import('./pages/SettingsPage.js') },
  ],
  widgets: {
    'youtube.month': () => import('./widgets.js').then((m) => ({ default: m.MonthWidget })),
    'youtube.managers': () => import('./widgets.js').then((m) => ({ default: m.ManagersWidget })),
    'youtube.missing': () => import('./widgets.js').then((m) => ({ default: m.MissingWidget })),
    'youtube.sync': () => import('./widgets.js').then((m) => ({ default: m.SyncWidget })),
  },
});
